export default __webpack_public_path__ + "static/media/img10.c0dc9292.png";